module.exports = __webpack_public_path__ + "img/9.404125d1.jpg";